'use client'

import { Typography } from '../Contentful'

function ProsAndConsContent({ content }) {
  return (
    <div className="flex flex-col lg:flex-row gap-4">
      <div className="w-full bg-white rounded-xl shadow-sm">
        <div className="p-2 bg-green-500 rounded-t-xl opacity-60"></div>
        <div className="p-4 flex flex-col">
          <div className="border-t-4 border-green-500 rounded-t-xl pt-2">
            <Typography content={'Pros'} className="bodyMd" />
          </div>
          <Typography content={content.pros} className="bodyMd" />
        </div>
      </div>
      <div className="w-full bg-white rounded-xl shadow-sm">
        <div className="p-2 bg-red-500 rounded-t-xl opacity-60"></div>
        <div className="p-4 flex flex-col">
          <div className="border-t-4 border-green-500 rounded-t-xl pt-2">
            <Typography content={'Cons'} className="bodyMd" />
          </div>
          <Typography content={content.cons} className="bodyMd" />
        </div>
      </div>
    </div>
  )
}

export { ProsAndConsContent }
